(function () {
  const ENHANCE_SELECTOR = [
    'select[class*="contact-main-input"]',
  ].join(', ');

  const CHEVRON =
    '<svg class="ps-custom-select__chevron" width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function initCustomSelects(root = document) {
    root.querySelectorAll(ENHANCE_SELECTOR).forEach((select) => {
      if (select.closest('.ps-custom-select') || select.dataset.psCustomSelect === 'true') return;
      enhanceSelect(select);
    });
  }

  function enhanceSelect(select) {
    select.dataset.psCustomSelect = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'ps-custom-select';
    if (select.className) wrapper.dataset.selectClass = select.className;

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'ps-custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.id = select.id ? `${select.id}-trigger` : '';
    if (select.id) {
      const label = document.querySelector(`label[for="${select.id}"]`);
      if (label) {
        trigger.setAttribute('aria-labelledby', label.id || `${select.id}-label`);
        if (!label.id) label.id = `${select.id}-label`;
      }
    }

    const labelSpan = document.createElement('span');
    labelSpan.className = 'ps-custom-select__label';
    trigger.appendChild(labelSpan);
    trigger.insertAdjacentHTML('beforeend', CHEVRON);

    const list = document.createElement('ul');
    list.className = 'ps-custom-select__list';
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    if (select.id) list.id = `${select.id}-listbox`;
    if (trigger.id && list.id) trigger.setAttribute('aria-controls', list.id);

    const options = Array.from(select.options);
    let focusedIndex = -1;

    options.forEach((option, index) => {
      const item = document.createElement('li');
      item.className = 'ps-custom-select__option';
      item.setAttribute('role', 'option');
      item.dataset.value = option.value;
      item.textContent = option.textContent.trim();

      if (option.disabled) {
        item.classList.add('is-disabled');
        item.setAttribute('aria-disabled', 'true');
      }

      if (option.selected) {
        item.classList.add('is-selected');
        item.setAttribute('aria-selected', 'true');
        updateTriggerLabel(labelSpan, option);
      } else {
        item.setAttribute('aria-selected', 'false');
      }

      item.addEventListener('click', () => {
        if (option.disabled) return;
        chooseOption(select, options, item, index, labelSpan, list, trigger);
      });

      list.appendChild(item);
    });

    select.classList.add('ps-custom-select__native');
    select.tabIndex = -1;

    const parent = select.parentNode;
    parent.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(trigger);
    wrapper.appendChild(list);

    trigger.addEventListener('click', () => toggleList(list, trigger));
    trigger.addEventListener('keydown', (event) =>
      handleTriggerKeydown(event, list, trigger, options, select, labelSpan)
    );
    list.addEventListener('keydown', (event) =>
      handleListKeydown(event, list, trigger, options, select, labelSpan, () => focusedIndex, (i) => {
        focusedIndex = i;
      })
    );

    document.addEventListener('click', (event) => {
      if (!wrapper.contains(event.target)) closeList(list, trigger);
    });

    select.addEventListener('change', () => syncFromNative(select, list, labelSpan));
  }

  function updateTriggerLabel(labelSpan, option) {
    labelSpan.textContent = option.textContent.trim();
    if (option.disabled || !option.value) labelSpan.classList.add('is-placeholder');
    else labelSpan.classList.remove('is-placeholder');
  }

  function chooseOption(select, options, item, index, labelSpan, list, trigger) {
    select.selectedIndex = index;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    list.querySelectorAll('.ps-custom-select__option').forEach((node) => {
      node.classList.remove('is-selected', 'is-focused');
      node.setAttribute('aria-selected', 'false');
    });

    item.classList.add('is-selected');
    item.setAttribute('aria-selected', 'true');
    updateTriggerLabel(labelSpan, options[index]);
    closeList(list, trigger);
    trigger.focus();
  }

  function syncFromNative(select, list, labelSpan) {
    const selected = select.options[select.selectedIndex];
    list.querySelectorAll('.ps-custom-select__option').forEach((node, index) => {
      const isSelected = index === select.selectedIndex;
      node.classList.toggle('is-selected', isSelected);
      node.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });
    if (selected) updateTriggerLabel(labelSpan, selected);
  }

  function toggleList(list, trigger) {
    if (list.hidden) openList(list, trigger);
    else closeList(list, trigger);
  }

  function openList(list, trigger) {
    list.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-open');
    const selected = list.querySelector('.is-selected:not(.is-disabled)');
    const first = list.querySelector('.ps-custom-select__option:not(.is-disabled)');
    const target = selected || first;
    if (target) {
      list.querySelectorAll('.is-focused').forEach((n) => n.classList.remove('is-focused'));
      target.classList.add('is-focused');
      target.scrollIntoView({ block: 'nearest' });
    }
  }

  function closeList(list, trigger) {
    list.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove('is-open');
    list.querySelectorAll('.is-focused').forEach((n) => n.classList.remove('is-focused'));
  }

  function handleTriggerKeydown(event, list, trigger, options, select, labelSpan) {
    if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      openList(list, trigger);
    } else if (event.key === 'Escape') {
      closeList(list, trigger);
    }
  }

  function handleListKeydown(event, list, trigger, options, select, labelSpan, getFocused, setFocused) {
    const items = Array.from(list.querySelectorAll('.ps-custom-select__option:not(.is-disabled)'));
    let index = items.indexOf(list.querySelector('.is-focused'));

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      index = Math.min(index + 1, items.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      index = Math.max(index - 1, 0);
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (index >= 0) items[index].click();
      return;
    } else if (event.key === 'Escape') {
      event.preventDefault();
      closeList(list, trigger);
      trigger.focus();
      return;
    } else {
      return;
    }

    list.querySelectorAll('.is-focused').forEach((n) => n.classList.remove('is-focused'));
    if (items[index]) {
      items[index].classList.add('is-focused');
      items[index].scrollIntoView({ block: 'nearest' });
      setFocused(index);
    }
  }

  document.addEventListener('DOMContentLoaded', () => initCustomSelects());
  document.addEventListener('shopify:section:load', (event) => initCustomSelects(event.target));
})();
